import { ShowCorrectNameInterface } from "./showCorrectName.interface";
import { allFormatRegex } from "../../../../scripts/helpers";

function NameDisplay(props: ShowCorrectNameInterface): JSX.Element {
    const languageIdentify = (name: string) => {
        if (!name) return "en";
        let p = /[پچجحخهعغفقثصضشسیبلاتنمکگوئدذرزطظژؤإأءًٌٍَُِّ\s]+$/;
        if (!name[0].match(p)) {
            return "en";
        }
        return "fa";
    };

    const getFileType = (name: string) => {
        const formatList = name.match(allFormatRegex);
        if (formatList && formatList.length) return formatList[0];
        else return "";
    };

    const getFileName = (name: string) => {
        const formatList = name.match(allFormatRegex);
        if (formatList && formatList.length) return name.replace(formatList[0], "");
        else return name;
    };

    return (
        <span dir={"ltr"}>
            <span className="truncate" dir={languageIdentify(props.TextInput) === "en" ? "ltr" : "rtl"}>
                {getFileName(props.TextInput)}
            </span>
            <span>{getFileType(props.TextInput)}</span>
        </span>
    );
}

export default NameDisplay;
